module.exports = __webpack_public_path__ + "static/media/spin-win-qr-code.914137aa.png";